module.exports = __webpack_public_path__ + "img/logo-le-monde.svg";